import { Stack, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import IBuyPaper from "components/displays/iBuyPaper";
import { MOBILE_MEDIA_QUERY } from "constants/mediaQueries";
import React from "react";

const InvoiceSearchSkeleton = () => {
    const isDesktop = useMediaQuery(MOBILE_MEDIA_QUERY);
    return isDesktop ? (
        <Grid container spacing={2}>
            {[...Array(3).keys()].map((v) => (
                <Grid item xs={4} md={4} key={v}>
                    <Skeleton
                        aria-label="table1"
                        height={40}
                        width="80%"
                        sx={{
                            borderRadius: "10px",
                            boxSizing: "border-box",
                        }}
                    />
                    <Skeleton
                        height={30}
                        width="90%"
                        sx={{
                            borderRadius: "10px",
                            boxSizing: "border-box",
                            mr: "16px",
                        }}
                    />
                </Grid>
            ))}
        </Grid>
    ) : (
        <Stack spacing={2}>
            {[...Array(3).keys()].map((v) => (
                <IBuyPaper key={v}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                            >
                                <Skeleton
                                    variant="text"
                                    width="20%"
                                    height={40}
                                />
                                <Skeleton
                                    variant="text"
                                    width="7%"
                                    height={30}
                                />
                            </Stack>
                        </Grid>
                        {[...Array(5).keys()].map((v) => (
                            <Grid
                                item
                                xs={12}
                                container
                                spacing={1}
                                ml={0.5}
                                key={v}
                            >
                                <Skeleton
                                    variant="text"
                                    width="40%"
                                    height={30}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </IBuyPaper>
            ))}
        </Stack>
    );
};
export default InvoiceSearchSkeleton;
